import pairingErrors from '../consts/device/pairingErrors';
import {makeSelectIotDeviceFullData} from '../state/selectors/consumer';
import {
    makeSelectIsDeviceNotSupported,
    makeSelectIsDeviceReady,
    makeSelectIsWrongDevice,
} from '../state/selectors/iotDevice';
import {makeSelectIsYapDeviceInfoReceived, makeSelectIsYapHolderInfoReceived} from '../state/selectors/yapEncrypted';
import {getState} from '../state/store';
import helpers from '../utils/helpers';
import pairingService from './pairingService';

let instance = null;

export default class ErrorHandlerService {
    constructor() {
        if (instance) {
            return instance;
        }

        instance = this;
        this.pairingErrorHandler = null;
    }

    setPairingErrorHandler({handler}) {
        this.pairingErrorHandler = handler;
    }

    removeErrorHandler() {
        this.pairingErrorHandler = null;
    }

    checkYapError(isHolder) {
        const state = getState();
        const isDeviceReady = makeSelectIsDeviceReady()(state);
        const isYapDeviceInfoReceived = makeSelectIsYapDeviceInfoReceived()(state);
        const isYapHolderInfoReceived = makeSelectIsYapHolderInfoReceived()(state);
        const isInfoReceived = isHolder ? isYapHolderInfoReceived : isYapDeviceInfoReceived;
        const iotProduct = makeSelectIotDeviceFullData()(state);
        const {holder, device} = iotProduct || {};
        const {isHolderConnected} = device || {};
        const {deviceSerialNumber} = holder || {};

        if ((isDeviceReady || (isHolderConnected && deviceSerialNumber)) && isInfoReceived) return;

        if (typeof this.pairingErrorHandler === 'function') {
            const getCode = () => {
                const isWrongDevice = makeSelectIsWrongDevice()(state);

                if (isWrongDevice) return pairingErrors.ERROR_WRONG_DEVICE;

                const isDeviceNotSupported = makeSelectIsDeviceNotSupported()(state);

                if (isDeviceNotSupported) return pairingErrors.ERROR_NOT_SUPPORTED_DEVICE;

                return pairingErrors.ERROR_PAIRING;
            };
            const code = getCode();

            helpers.runFunction(this.pairingErrorHandler, code);
        } else {
            if (isHolder) {
                pairingService.disconnectAndClearHolderState();
            } else {
                pairingService.disconnectAndShowCriticalGuide();
            }
        }
    }
}
